import { baseApi } from './baseApi'
import { Patient } from 'store/types'
import {
  PatientsList,
  PatientsListQuery,
} from 'ts-back-end/src/business/patient/dto/patient-list.dto'

export const patientApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatients: builder.query<PatientsList, { [key: string]: string | number }>({
      query: (query) => ({ url: `/dme/patients`, params: query }),
    }),
    getPatient: builder.query<Patient, { id: number }>({
      query: ({ id }) => ({ url: `/dme/patients/${id}` }),
    }),
    updatePatient: builder.mutation<Patient, Partial<Patient>>({
      query: (data) => ({
        method: `PATCH`,
        url: `/dme/patients/${data.id}`,
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => ['Order', 'Patient'],
    }),
    getLabPatientList: builder.query<PatientsList, PatientsListQuery>({
      query: (query) => ({ url: `/lab/patients/list`, params: query }),
      providesTags: ['Patient'],
    }),
    getLabPatient: builder.query<Patient, { id: number }>({
      query: ({ id }) => ({ url: `/lab/patients/${id}` }),
      providesTags: (result, error, { id }) => [{ type: 'Patient', id: Number(id) }],
    }),
    movePatient: builder.mutation<void, { patientId: number; officeId: number }>({
      query: ({ patientId, officeId }) => ({
        method: 'POST',
        url: `/lab/patients/${patientId}/move`,
        body: { officeId },
      }),
      invalidatesTags: (result, error, { patientId }) => [{ type: 'Patient', id: patientId }],
    }),
    updatePatientTag: builder.mutation<void, { patientId: number; tagId: string | null; tagText?: string | null }>({
      query: ({ patientId, tagId, tagText }) => ({
        method: 'PATCH',
        url: `/lab/patients/${patientId}/tag`,
        body: { tagId, tagText: tagText || null },
      }),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'Patient', id: patientId },
        'Order',
        'OrderList',
      ],
    }),
    // The DME the patient chose; null clears it (TES-3159).
    setPatientPreferredDme: builder.mutation<void, { patientId: number; preferredDmeOfficeId: number | null }>({
      query: ({ patientId, preferredDmeOfficeId }) => ({
        method: 'PATCH',
        url: `/lab/patients/${patientId}/preferred-dme`,
        body: { preferredDmeOfficeId },
      }),
      invalidatesTags: (result, error, { patientId }) => [{ type: 'Patient', id: patientId }],
    }),
  }),
})

export const {
  useGetPatientsQuery,
  useLazyGetPatientsQuery,
  useUpdatePatientMutation,
  useGetPatientQuery,
  useGetLabPatientListQuery,
  useLazyGetLabPatientListQuery,
  useGetLabPatientQuery,
  useLazyGetLabPatientQuery,
  useMovePatientMutation,
  useUpdatePatientTagMutation,
  useSetPatientPreferredDmeMutation,
} = patientApi
